import React from 'react';
import { get } from 'lodash';

import type { CampaignOverview } from 'types';

import { t } from 'utils/language';

type Props = {
  overview: CampaignOverview | undefined | null
};

const CampaignsTableCreatorsCell = ({
  overview
}: Props) => (
  <div className="campaigns-table-creators-cell">
    <div className="campaigns-table-creators-cell__row">
      <div className="campaigns-table-creators-cell__key">
        {`${t('campaigns_table.creators_agreed_label')}:`}
      </div>
      <div className="campaigns-table-creators-cell__value">
        {get(overview, 'acceptedOverview.creators', 0)}
      </div>
    </div>
    <div className="campaigns-table-creators-cell__row campaigns-table-creators-cell__row--light">
      <div className="campaigns-table-creators-cell__key">
        {`${t('campaigns_table.creators_pending_label')}:`}
      </div>
      <div className="campaigns-table-creators-cell__value">
        {get(overview, 'pendingOverview.creators', 0)}
      </div>
    </div>
  </div>
);

export default CampaignsTableCreatorsCell;
